import { Input } from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import { LoadingContainer } from 'app/components/LoadingContainer';
import ModalContainer from 'app/components/ModalContainer';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import StyledSelect from '../../components/StyledSelect';
import {
  normalizePhoneInput,
  validateField,
  validateForm,
} from '../utils/validate';
import FormItemContainer from './FormItemContainer';
import NumberField from './NumberField';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import useFetchData from 'app/hooks/useFetchData';
import {
  createBookingSlotApi,
  getAvailableBookingSlotApi,
  getZoneListApi,
  updateBookingSlotApi,
} from 'app/services/bookingSlotApi';
import { IDataSlot, IFilterBookingSlotSearch } from './CheckBookingSlots';
import { IFilterBookingHistorySearch } from './BookingHistory';
import _ from 'lodash';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import { useHistory } from 'react-router-dom';
type typeModal = 'create' | 'update';
type IFilterBookingCombined = Partial<
  IFilterBookingSlotSearch & IFilterBookingHistorySearch
>;
interface BookingModalProps {
  // data: Record<string, any> | null;
  data: IDataSlot | null;
  onCloseModal: (isCallApi?: boolean) => void;
  isShow: boolean;
  typeModal: typeModal;
  filter?: IFilterBookingCombined;
}
interface IFormData {
  ticketNumber?: number;
  zone?: string;
  childrenQuantity?: number;
  customerNationality?: string;
  note?: string;
  fullName: string;
  phoneNumber: string;
}
const initFormData = {
  ticketNumber: 1,
  zone: undefined,
  childrenQuantity: 0,
  customerNationality: '',
  note: '',
  fullName: '',
  phoneNumber: '',
};
type ErrorBookingModal = {
  ticketNumber?: string;
  zone?: string;
  childrenQuantity?: string;
  customerNationality?: string;
  note?: string;
  fullName?: string;
  phoneNumber?: string;
};
const hasError = error =>
  Object.values(error).some(v => v !== '' && v !== null && v !== undefined);
const BookingModal: React.FC<BookingModalProps> = props => {
  const {
    data: dataLocal,
    onCloseModal,
    isShow,
    typeModal = 'create',
    filter,
  } = props;
  const history = useHistory();
  const [data, setData] = useState<IDataSlot | null>(dataLocal);
  const [formData, setFormData] = useState<IFormData>(initFormData);
  const [error, setError] = useState<ErrorBookingModal>({});
  const [isLoadingSlot, setIsLoadingSlot] = useState(false);
  const translations = useSelector(selectTranslations);
  const { locale } = useGlobalFunction();

  // useEffect(() => {
  //   if (!_.isEmpty(data)) {
  //     const initForm = {
  //       ...formData,
  //       ticketNumber: data.quantity || 1,
  //       childrenQuantity: data.infantQuantity || undefined,
  //       customerNationality: data.customerNationality || '',
  //       note: data.note,
  //       zone: data?.zone || undefined,
  //       fullName: data?.fullName || '',
  //       phoneNumber: data?.phoneNumber || '',
  //     };
  //     setFormData(initForm);
  //     onFetchZoneList({ payloadData: { storeId: data?.storeId } });
  //   }
  // }, [data]);
  useEffect(() => {
    if (!_.isEmpty(dataLocal)) {
      setData(dataLocal);
      const initForm = {
        ...formData,
        ticketNumber: dataLocal.quantity || 1,
        childrenQuantity: dataLocal.infantQuantity || 0,
        customerNationality: dataLocal.customerNationality || '',
        note: dataLocal.note,
        zone: dataLocal?.zone || undefined,
        fullName: dataLocal?.fullName || '',
        phoneNumber: dataLocal?.phoneNumber || '',
      };
      setFormData(initForm);
      onFetchZoneList({ payloadData: { storeId: dataLocal?.storeId } });
      setIsLoadingSlot(true);
    }
  }, [dataLocal]);
  const { onFetchData: onFetchAvailableBookingSlot } = useFetchData({
    actionApi: getAvailableBookingSlotApi,
    IIFE: false,
  });
  const onChangeArea = val => {
    handleChange('zone', val);
  };
  const onClickBack = ({ isCallApi = false }) => {
    setError({});
    onCloseModal?.(isCallApi);
  };
  const { onFetchData: onFetchZoneList, result: resZoneList } = useFetchData({
    actionApi: getZoneListApi,
    IIFE: false,
  });
  useEffect(() => {
    if (_.isEmpty(resZoneList)) return;
    fetchAllSlots();
  }, [resZoneList]);
  const fetchAllSlots = async () => {
    if (_.isEmpty(resZoneList) || !data) return;
    if (resZoneList?.length === 1 && resZoneList[0]?.zoneId && !formData.zone) {
      setFormData(prev => ({
        ...prev,
        zone: resZoneList[0].zoneId,
      }));
    }
    setIsLoadingSlot(true);

    const responses: any[] = [];
    try {
      for (const zone of resZoneList) {
        try {
          const res = await onFetchAvailableBookingSlot({
            payloadData: {
              zoneId: zone.zoneId,
              arrivalDate: data.orderDate
                ? moment(data.orderDate, ['YYYY-MM-DD', 'DD/MM/YYYY']).format(
                    'YYYY-MM-DD',
                  )
                : undefined,
            },
          });
          if (res) responses.push(res);
        } catch (err) {
          console.error('Fetch slot error zone:', zone.zoneId, err);
          // fallback tránh mất UI
          responses.push({
            zoneId: zone.zoneId,
            numberOfUnused: 0,
            numberOfUsed: 0,
          });
        }
      }
      mergeSlotData(responses);
    } finally {
      setIsLoadingSlot(false);
    }
  };
  const mergeSlotData = (responses: any[]) => {
    const dataZoneTemp = resZoneList.map((zone: any) => {
      const matched = responses.find(
        res => String(res?.zoneId || res?.zoneID) === String(zone.zoneId),
      );
      const quantityForZone =
        String(zone.zoneId) === String(data?.zone) ? data?.quantity || 0 : 0;
      return {
        id: zone.zoneId,
        name: `Zone ${zone.zoneId} (${
          locale === 'vi' ? zone.zoneNameVn : zone.zoneNameEn
        })`,
        slot: (matched?.numberOfUnused || 0) + quantityForZone,
      };
    });
    const totalAvailableSlot = dataZoneTemp.reduce(
      (acc, cur) => acc + cur.slot,
      0,
    );
    const totalUsed = responses.reduce(
      (acc, cur) => acc + (cur?.numberOfUsed || 0),
      0,
    );
    setData(prev => ({
      ...prev,
      totalAvailableSlot,
      numberOfUsed: totalUsed,
      dataZone: dataZoneTemp,
    }));
  };
  const optionArea: any = useMemo(() => {
    return resZoneList?.map(zone => ({
      label: locale === 'vi' ? zone.zoneNameVn : zone.zoneNameEn,
      value: zone.zoneId,
    }));
  }, [resZoneList, locale]);
  const {
    onFetchData: onFetchCreateBookingSlot,
    isLoading: isLoadingCreateBookingSlot,
  } = useFetchData({
    actionApi: createBookingSlotApi,
    IIFE: false,
    onSuccess: response => {
      onClickBack({ isCallApi: true });
      history.replace(`/restaurant/booking-slots?screen=booking-history`);
    },
    onError: err => {
      fetchAllSlots();
    },
  });
  const {
    onFetchData: onFetchUpdateBookingSlot,
    isLoading: isLoadingUpdateBookingSlot,
  } = useFetchData({
    actionApi: updateBookingSlotApi,
    IIFE: false,
    onSuccess: response => {
      onClickBack({ isCallApi: true });
    },
  });
  const onClickConfirm = () => {
    const newError = validateForm(formData, translations);
    setError(newError);
    if (hasError(newError)) return;
    let params = {
      quantity: formData.ticketNumber,
      infantQuantity: formData.childrenQuantity || 0,
      representativeName: formData.fullName,
      representativePhone: formData.phoneNumber,
      arrivalDate: data?.orderDate
        ? moment(data?.orderDate, ['YYYY-MM-DD', 'DD/MM/YYYY']).format(
            'YYYY-MM-DD',
          )
        : '',
      storeId: data?.storeId,
      ticketShowId: data?.productId,
      zoneId: formData.zone,
      note: formData.note,
      country: formData.customerNationality,
      reservationCode: '',
      referenceCode: '',
    };
    if (typeModal === 'create') {
      onFetchCreateBookingSlot({ payloadData: params });
    } else if (typeModal === 'update') {
      params.reservationCode = data?.reservationCode || '';
      params.referenceCode = data?.referenceCode || '';
      onFetchUpdateBookingSlot({ payloadData: params });
    }
  };

  const handleChange = (name: keyof IFormData, value: any) => {
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    if (error[name]) {
      const message = validateField(name, value, translations);
      setError(prev => ({
        ...prev,
        [name]: message || undefined,
      }));
    }
  };
  const handleBlur = (name: keyof IFormData, value: any) => {
    const trimmed = typeof value === 'string' ? value.trim() : value;
    setFormData(prev => ({
      ...prev,
      [name]: trimmed,
    }));
    const message = validateField(name, trimmed, translations);
    setError(prev => ({
      ...prev,
      [name]: message || undefined,
    }));
  };
  return (
    <ModalContainer
      isShow={isShow}
      onCloseDialog={() => onCloseModal(false)}
      styleSlots={{
        modalContentStyle: {
          width: '90vw',
          maxWidth: 700,
          height: 'auto',
          padding: 30,
          borderRadius: 10,
          overflow: 'auto',
        },
        iconWrapperStyle: {
          margin: 0,
        },
      }}
      maskClosable={false}
      modalProps={{
        destroyOnClose: true,
      }}
      CloseIcon={<></>}
    >
      <LoadingContainer
        loading={
          isLoadingCreateBookingSlot ||
          isLoadingUpdateBookingSlot ||
          isLoadingSlot
        }
      >
        <Title>
          {
            translations?.[
              typeModal === 'update'
                ? 'b2b.txt.editReservation'
                : 'b2b.txt.makeReservation'
            ]
          }
        </Title>
        <SubTitle ellipsis={{ rows: 2 }}>{data?.ticketName}</SubTitle>
        <InfoCard>
          <div>
            <b>
              {translations?.['b2b.txt.totalAvailableSlots']
                .replace(
                  '${day}',
                  data?.orderDate
                    ? moment(data?.orderDate, [
                        'YYYY-MM-DD',
                        'DD/MM/YYYY',
                      ]).format('DD/MM/YYYY')
                    : '',
                )
                .replace('${n}', data?.totalAvailableSlot || 0)}
            </b>
          </div>
          <BoxZone>
            {(data?.dataZone || [])?.map((zone, index) => {
              return (
                <div key={String(zone?.id || index)}>
                  {zone?.name}:&nbsp;<b>{zone.slot}</b>&nbsp;slots
                </div>
              );
            })}
          </BoxZone>
        </InfoCard>
        <Note>{translations?.['b2b.txt.slotLimitWarning']}</Note>
        <FormGrid>
          <FormItemContainer
            label={translations?.['b2b.txt.ticketAmount']}
            required
            error={error.ticketNumber}
          >
            <NumberField
              value={formData.ticketNumber}
              placeholder={translations?.['b2b.txt.enterTicketQuantity']}
              error={!!error.ticketNumber}
              min={1}
              max={1000}
              maxLength={4}
              onChange={value => handleChange('ticketNumber', value)}
              onBlur={() => handleBlur('ticketNumber', formData.ticketNumber)}
            />
          </FormItemContainer>
          <FormItemContainer
            label={translations?.['b2b.txt.zone']}
            required
            error={error.zone}
          >
            <StyledSelect
              showSearch
              isFocus
              value={formData.zone}
              suffixIcon={<ArrowDownIcon />}
              placeholder={
                translations ? translations?.['b2b.txt.selectArea'] : ''
              }
              onChange={val => onChangeArea(val)}
              options={optionArea}
              style={{ width: '100%' }}
              allowClear
              getPopupContainer={trigger => trigger.parentElement}
              error={!!error.zone}
              onBlur={() => handleBlur('zone', formData.zone)}
            />
          </FormItemContainer>
          <FormItemContainer
            label={translations?.['b2b.txt.childrenQuantityFree']}
            required
            error={error.childrenQuantity}
          >
            <NumberField
              value={formData.childrenQuantity}
              placeholder={translations?.['b2b.txt.enterChildrenQuantity']}
              error={!!error.childrenQuantity}
              min={0}
              max={1000}
              maxLength={4}
              onChange={value => handleChange('childrenQuantity', value)}
              onBlur={() =>
                handleBlur('childrenQuantity', formData.childrenQuantity)
              }
            />
          </FormItemContainer>
          <FormItemContainer
            label={translations?.['b2b.txt.customerNationality']}
          >
            <StyledInput
              value={formData.customerNationality}
              placeholder={translations?.['b2b.txt.enterCustomerNationality']}
              onChange={e => {
                handleChange('customerNationality', e.target.value);
              }}
              onBlur={e => handleBlur('customerNationality', e.target.value)}
              maxLength={100}
            />
          </FormItemContainer>
        </FormGrid>
        <FormItemContainer
          label={translations?.['b2b.form.tourNotes']}
          style={{ marginTop: 16 }}
        >
          <StyledTextArea
            value={formData.note}
            placeholder={translations?.['b2b.txt.input-note']}
            onChange={e => {
              handleChange('note', e.target.value);
            }}
            onBlur={e => handleBlur('note', e.target.value)}
            maxLength={255}
          />
        </FormItemContainer>
        <SectionTitle>
          {translations?.['b2b.txt.representiveInfo']}
        </SectionTitle>
        <FormGrid>
          <FormItemContainer
            required
            label={translations?.['b2b.form.name']}
            error={error.fullName}
          >
            <StyledInput
              value={formData.fullName}
              placeholder={translations?.['b2b.txt.enterFullName']}
              onChange={e => {
                handleChange('fullName', e.target.value);
              }}
              onBlur={e => handleBlur('fullName', e.target.value)}
              maxLength={100}
              error={!!error.fullName}
            />
          </FormItemContainer>
          <FormItemContainer
            required
            label={translations?.['b2b.txt.phoneNumberLabel']}
            error={error.phoneNumber}
          >
            <StyledInput
              value={formData.phoneNumber}
              placeholder={translations?.['b2c.form.input-phone']}
              inputMode="numeric"
              onChange={e => {
                const value = normalizePhoneInput(e.target.value);
                handleChange('phoneNumber', value);
              }}
              onBlur={e => handleBlur('phoneNumber', e.target.value)}
              maxLength={15}
              error={!!error.phoneNumber}
            />
          </FormItemContainer>
        </FormGrid>
        <ButtonRow>
          <Button onClick={() => onClickBack({ isCallApi: false })}>
            {
              translations?.[
                typeModal === 'update' ? 'b2b.btn.cancel' : 'b2b.txt.back'
              ]
            }
          </Button>
          <Button primary onClick={onClickConfirm}>
            {
              translations?.[
                typeModal === 'update'
                  ? 'b2b.txt.updateOrder'
                  : 'b2b.txt.btn-confirm'
              ]
            }
          </Button>
        </ButtonRow>
      </LoadingContainer>
    </ModalContainer>
  );
};
export default BookingModal;
const Title = styled.h1`
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 6px;
`;
const SubTitle = styled(TooltipParagraph)`
  text-align: center;
  color: #444;
  font-size: 16px;
  margin-bottom: 24px;
`;
const InfoCard = styled.div`
  background: #f3f4f6;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
`;
const Note = styled.div`
  color: var(--color-9);
  font-size: 12px;
  margin-bottom: 10px;
`;
const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
`;
const StyledInput = styled(Input)<{ error?: boolean }>`
  height: 44px;
  border: 1px solid ${({ error }) => (error ? 'var(--color-10)' : '#dcdcdc')};
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  &:focus,
  &.ant-input:focus {
    border-color: ${({ error }) => (error ? 'var(--color-10)' : '#2997ff')};
    box-shadow: none;
  }

  &:hover {
    border-color: ${({ error }) => (error ? 'var(--color-10)' : '#2997ff')};
  }
`;
const StyledTextArea = styled(Input.TextArea)`
  border-radius: 8px;
  padding: 12px;
  min-height: 90px;
  &::placeholder {
    font-style: italic;
  }
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9c9;
    border-radius: 10px;
  }
  @-moz-document url-prefix() {
    .rc-virtual-list-holder {
      scrollbar-width: thin;
      scrollbar-color: #d9d9d9c9 transparent;
    }
  }
  resize: none;
`;
const SectionTitle = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 700;
`;
const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-bottom: 30px;
  gap: 20px;
`;
const Button = styled.button<{ primary?: boolean }>`
  height: 42px;
  width: 180px;
  border-radius: 6px;
  border: 1px solid
    ${({ primary }) => (primary ? 'var(--color-4)' : 'var(--color-4)')};
  background: ${({ primary }) => (primary ? 'var(--color-gradient)' : '#fff')};
  color: ${({ primary }) => (primary ? '#fff' : 'var(--color-4)')};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
const BoxZone = styled.div`
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 30px;
`;
